import HttpService from "./HttpService";

let avaliacaoService = {

    buscarListaDeAvaliacao: () => {
        return HttpService.backApi.get('/avaliacao');
    },

    salvarAvaliacao: (avaliacao) => {
        return HttpService.backApi.post('/avaliacao/salvar', avaliacao);
    },

    updateAvaliacao: (avaliacao) => {
        return HttpService.backApi.put('/avaliacao/update', avaliacao);
    },

    deletarAvaliacao: (avaliacao) => {
        return HttpService.backApi.delete(`/avaliacao/${avaliacao.id}`)
    }
};

export default avaliacaoService;
